module.exports = __webpack_public_path__ + "static/media/0030_Medium.e47f9313.jpg";